export enum FeatureFlags {
  priorExercises = 'priorExercises',
  ICD11 = 'ICD11',
  workFlows = 'workFlows',
  messaging = 'messaging',
  voiceToChart = 'voiceToChart',
  compensationCalculator = 'compensationCalculator',
  apiIntegrations = 'apiIntegrations',
  supplementsAndSuppliesOnTreatmentPurchase = 'supplementsAndSuppliesOnTreatmentPurchase',
  ehr = 'ehr',
  nationalDrugCode = 'nationalDrugCode',
  statementNotes = 'statementNotes',
  insuranceEligibility = 'insuranceEligibility',
  encounterTrack = 'encounterTrack',
  upvoty = 'upvoty',
  providerLevelBillingProfiles = 'providerLevelBillingProfiles',
  multipleSupervisingProviders = 'multipleSupervisingProviders',
  improvedVisibilityBatchClaims = 'improvedVisibilityBatchClaims',
  instantInsuranceEligibility = 'instantInsuranceEligibility',
  collaborativeEncounter = 'collaborativeEncounter',
}

export enum FlagGroups {
  everyone = 'everyone',
  beta = 'beta',
  alpha = 'alpha',
  internal = 'internal',
}

export const flagGroupsArr = [
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Alpha',
    value: 'alpha',
  },
  {
    label: 'Beta',
    value: 'beta',
  },
  {
    label: 'Everyone',
    value: 'everyone',
  },
];
